var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandArea = function SvgLandArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#F2FAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.62 15.329 3.783-3.783c.35-.35.95-.1.95.394v17.856c0 .308-.249.557-.556.557H11.94a.557.557 0 0 1-.394-.95l3.783-3.784 1.563 1.564a.557.557 0 1 0 .788-.788l-1.564-1.563 1.589-1.588 1.563 1.563a.557.557 0 0 0 .787-.788l-1.563-1.563 1.589-1.588 1.563 1.563a.557.557 0 0 0 .787-.788l-1.563-1.563 1.589-1.588 1.563 1.563a.557.557 0 0 0 .787-.787l-1.563-1.564 1.589-1.588 1.563 1.563a.557.557 0 0 0 .787-.787l-1.563-1.563Zm.575 11.423c.308 0 .557-.25.557-.557v-5.049c0-.495-.6-.743-.95-.393L20.753 25.8c-.35.35-.1.95.394.95h5.049Z",
    fill: "#58B847"
  })));
};
export default SvgLandArea;